export interface FamilyMember {
  id: string
  firstName: string
  lastName: string
  role: string
  initials: string
  hasCard: boolean
  photo: string
  canEdit: boolean
}

export interface EditableField {
  id: string
  label: string
  placeholder: string
  requiresProof: boolean
  proofLabel?: string
}

export const editableFields: EditableField[] = [
  {
    id: 'prenom',
    label: 'First name',
    placeholder: 'Bryon',
    requiresProof: true,
    proofLabel: 'Birth certificate or photo ID',
  },
  {
    id: 'nom',
    label: 'Last name',
    placeholder: 'Mickelson',
    requiresProof: true,
    proofLabel: 'Government-issued photo ID',
  },
  { id: 'genre', label: 'Gender', placeholder: 'Male', requiresProof: false },
  { id: 'photo', label: 'Card photo', placeholder: 'New photo', requiresProof: false },
  {
    id: 'adresse',
    label: 'Address',
    placeholder: '5108 - 46 Street, Bonnyville',
    requiresProof: false,
    proofLabel: 'Proof of residency (lease, tax notice, driver’s licence)',
  },
]

export const verifiedAddresses = [
  { id: 'primary', label: '5108 - 46 Street, Bonnyville', note: 'Primary address · verified' },
  { id: 'second', label: '4703 - 51 Avenue, Bonnyville', note: 'Second property · verified' },
]

export const memberValues: Record<string, Record<string, string>> = {
  bryon: {
    prenom: 'Bryon',
    nom: 'Mickelson',
    genre: 'Male',
    photo: 'Current photo',
    adresse: '5108 - 46 Street, Bonnyville',
  },
  charlotte: {
    prenom: 'Charlotte',
    nom: 'Mickelson',
    genre: 'Female',
    photo: 'Current photo',
    adresse: '5108 - 46 Street, Bonnyville',
  },
  emma: {
    prenom: 'Emma',
    nom: 'Mickelson',
    genre: 'Female',
    photo: 'Current photo',
    adresse: '5108 - 46 Street, Bonnyville',
  },
}

export const citizen = {
  firstName: 'Bryon',
  lastName: 'Mickelson',
  initials: 'BM',
  city: 'Bonnyville',
}

export const cardCredentials = ['Resident', 'Pool', 'Library', 'Recreation']

export interface WalletCard {
  id: string
  label: string
  number: string
  badge: string
  note: string
}

export const walletCards: WalletCard[] = [
  {
    id: 'citoyenne',
    label: 'Digital card',
    number: '0040327823',
    badge: 'Resident',
    note: 'Swimming Pool access valid until September 30',
  },
  {
    id: 'loisirs',
    label: 'Recreation',
    number: '0093612477',
    badge: 'Resident',
    note: 'Emma’s swim lesson · Saturday 10 a.m.',
  },
  {
    id: 'bibliotheque',
    label: 'Library',
    number: '0071845209',
    badge: 'Resident',
    note: '2 items due back before September 12',
  },
]

export const familyMembers: FamilyMember[] = [
  {
    id: 'bryon',
    firstName: 'Bryon',
    lastName: 'Mickelson',
    role: 'Cardholder',
    initials: 'BM',
    hasCard: true,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/6d75bf83-2bf9-4f1d-8912-8fecf05ffaa8.jpg',
    canEdit: true,
  },
  {
    id: 'charlotte',
    firstName: 'Charlotte',
    lastName: 'Mickelson',
    role: 'Spouse',
    initials: 'CM',
    hasCard: true,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/3ed6e46d-2ab5-4f53-8f0e-9919328bc5b5.jpg',
    canEdit: false,
  },
  {
    id: 'emma',
    firstName: 'Emma',
    lastName: 'Mickelson',
    role: 'Child',
    initials: 'EM',
    hasCard: false,
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/34fafd9b-c877-4154-8e6b-5e158dfa521f.jpg',
    canEdit: true,
  },
]
